import { ROUTES } from '../../constants/routes';
import { NotificationContent } from '../../types/notifications';

export interface NotificationDisplay {
  title: string;
  description: string;
  details: string[];
  preview?: string;
  to: string | null;
}

const getOrderPath = (content: NotificationContent): string | null => {
  if (typeof content.mold_order_id !== 'number') {
    return null;
  }

  return ROUTES.MOLD_ORDER_DETAIL.replace(':id', String(content.mold_order_id));
};

const getOrderCommentsPath = (content: NotificationContent): string | null => {
  const orderPath = getOrderPath(content);
  return orderPath ? `${orderPath}#comments` : null;
};

const getNumberText = (value: unknown, label: string) =>
  typeof value === 'number' ? `${label} #${value}` : '';

const getStringText = (value: unknown) =>
  typeof value === 'string' ? value.trim() : '';

const getOrderDescription = (content: NotificationContent) =>
  getNumberText(content.mold_order_id, 'ใบงาน');

const getActorDetail = (content: NotificationContent) =>
  getNumberText(content.actor_user_id, 'ผู้ดำเนินการ');

export function getNotificationDisplay(
  content: NotificationContent,
): NotificationDisplay {
  try {
    const id = content.mold_order_id;
    const idText = getOrderDescription(content);
    const to = getOrderPath(content);

    switch (content.type) {
      case 'order_assigned':
        return {
          title: 'คุณได้รับมอบหมายใบงาน',
          description: idText,
          details: [getActorDetail(content)].filter(Boolean),
          to,
        };
      case 'order_status_changed':
        return {
          title: 'ใบงานเปลี่ยนสถานะ',
          description:
            typeof id === 'number'
              ? `ใบงาน #${id}: ${content.from_state ?? ''} → ${content.to_state ?? ''}`
              : '',
          details: [getActorDetail(content)].filter(Boolean),
          to,
        };
      case 'approval_requested':
        return {
          title: 'รอการอนุมัติจากคุณ',
          description:
            typeof id === 'number'
              ? `ใบงาน #${id} · สถานะ ${content.state_name ?? ''}`
              : '',
          details: [getActorDetail(content)].filter(Boolean),
          to,
        };
      case 'comment_mentioned':
        return {
          title: 'มีคนกล่าวถึงคุณในความคิดเห็น',
          description: idText,
          details: [getActorDetail(content)].filter(Boolean),
          preview: getStringText(content.comment_preview),
          to: getOrderCommentsPath(content),
        };
      default:
        return {
          title: 'การแจ้งเตือน',
          description: idText,
          details: [getActorDetail(content)].filter(Boolean),
          to,
        };
    }
  } catch (error) {
    console.error('Failed to render notification content:', error);
    return {
      title: 'การแจ้งเตือน',
      description: '',
      details: [],
      to: null,
    };
  }
}
